<template>
  <v-container fluid  v-if="detalleEvaluacion.fiador_nombre_completo">

    <v-row>

      <v-col id="evaluacion" cols="12">
        <v-row>
          <v-col cols="9">
            <v-card>
              <v-card-title class="text-center justify-center">
                Evaluación
              </v-card-title>
              <v-card-text>
                <v-simple-table>
                  <tr>
                    <td class="text--secondary font-weight-bold text-body-2">
                      Número de evaluación
                    </td>
                    <td class="text--secondary font-weight-regular text-body-2" align="left">
                      {{ detalleEvaluacion.id }}
                    </td>
                  </tr>
                  <tr>
                    <td class="text--secondary font-weight-bold text-body-2">
                      Estado de evaluación
                    </td>
                    <td class="text--secondary font-weight-regular text-body-2" align="left">
                      {{ detalleEvaluacion.estado }}
                    </td>
                  </tr>
                  <tr>
                    <td class="text--secondary font-weight-bold text-body-2">
                      Resultado de la evaluacion
                    </td>
                    <td class="text--secondary font-weight-regular text-body-2" align="left">
                      <span :class="[
                        `${getColor(
                          detalleEvaluacion.fiador_resultado_evaluacion
                        )}--text`,
                      ]">{{ detalleEvaluacion.fiador_resultado_evaluacion || 'N/A' }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td class="text--secondary font-weight-bold text-body-2">
                      Fecha evaluación
                    </td>
                    <td class="text--secondary font-weight-regular text-body-2" align="left">
                      {{ fnGetDateTime(detalleEvaluacion.createdAt) }}
                    </td>
                  </tr>
                  <tr>
                    <td class="text--secondary font-weight-bold text-body-2">
                      Usuario móvil
                    </td>
                    <td class="text--secondary font-weight-regular text-body-2" align="left">
                      {{ detalleEvaluacion.CREADO_POR_USUARIO_NOMBRE }} (
                      {{ detalleEvaluacion.CREADO_POR_USUARIO }})
                    </td>
                  </tr>
                  <tr>
                    <td class="text--secondary font-weight-bold text-body-2">
                      Fecha campaña
                    </td>
                    <td class="text--secondary font-weight-regular text-body-2" align="left">
                      {{ fnGetDateUTC(detalleEvaluacion.fecha_campania) }}
                    </td>
                  </tr>
                  <tr>
                    <td class="text--secondary font-weight-bold text-body-2">
                      División
                    </td>
                    <td class="text--secondary font-weight-regular text-body-2" align="left">
                      {{ detalleEvaluacion.division }}
                    </td>
                  </tr>
                  <tr>
                    <td class="text--secondary font-weight-bold text-body-2">
                      Sector
                    </td>
                    <td class="text--secondary font-weight-regular text-body-2" align="left">
                      {{ detalleEvaluacion.sector }}
                    </td>
                  </tr>
                  <tr>
                    <td class="text--secondary font-weight-bold text-body-2">
                      Ruta
                    </td>
                    <td class="text--secondary font-weight-regular text-body-2" align="left">
                      {{ detalleEvaluacion.ruta }}
                    </td>
                  </tr>
                  <tr>
                    <td class="text--secondary font-weight-bold text-body-2">
                      Fue referida
                    </td>
                    <td class="text--secondary font-weight-regular text-body-2" align="left">
                      <span v-if="
                        detalleEvaluacion.flag_persona_referida_por_consejera ==
                        1
                      ">
                        Si
                      </span>
                      <span v-else>No</span>
                    </td>
                  </tr>
                  <tr v-if="
                    detalleEvaluacion.flag_persona_referida_por_consejera == 1
                  ">
                    <td class="text--secondary font-weight-bold text-body-2">
                      Código de referida
                    </td>
                    <td class="text--secondary font-weight-regular text-body-2" align="left">
                      {{ detalleEvaluacion.codigo_referencia }}
                    </td>
                  </tr>
                </v-simple-table>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="3">
            <v-img width="100%" alt="resultado evaluación"
              :src="imagenEstadoEvaluacion(detalleEvaluacion.fiador_resultado_evaluacion)" />
          </v-col>
        </v-row>

      </v-col>
      <v-col id="persona" cols="12">
        <v-card>
          <v-card-title class="text-center justify-center">
            Persona
          </v-card-title>
          <v-card-text>
            <v-simple-table dense>
              <tr>
                <td class="text--secondary font-weight-bold text-body-2">
                  Nombre de la persona
                </td>
                <td class="text--secondary font-weight-regular text-body-2" align="left">
                  {{ detalleEvaluacion.fiador_nombre_completo }}
                </td>
              </tr>
              <tr v-if="buroInternoResult && buroInternoResult.apiResponse && buroInternoResult.apiResponse.codigo">
                <td class="text--secondary font-weight-bold text-body-2">
                  Código en SAP
                </td>
                <td class="text--secondary font-weight-regular text-body-2" align="left">
                  {{ buroInternoResult?.apiResponse?.codigo }}
                </td>
              </tr>
              <tr>
                <td class="text--secondary font-weight-bold text-body-2">
                  Fecha de nacimiento
                </td>
                <td class="text--secondary font-weight-regular text-body-2" align="left">
                  {{ fnGetDateUTC(detalleEvaluacion.fiador_fecha_de_nacimiento) }}
                </td>
              </tr>
              <tr>
                <td class="text--secondary font-weight-bold text-body-2">
                  {{ documento_de_identificacion }}
                </td>
                <td class="text--secondary font-weight-regular text-body-2" align="left">
                  {{ detalleEvaluacion.fiador_numero_documento_identificacion }}
                </td>
              </tr>
              <tr>
                <td class="text--secondary font-weight-bold text-body-2">
                  {{ documento_de_identificacion }} extendido en
                </td>
                <td class="text--secondary font-weight-regular text-body-2" align="left">
                  {{
                    detalleEvaluacion.fiador_identificacion_extendida_en
                  }}
                </td>
              </tr>
              <tr>
                <td class="text--secondary font-weight-bold text-body-2">
                  Número de identificación tributaria
                </td>
                <td class="text--secondary font-weight-regular text-body-2" align="left">
                  {{ detalleEvaluacion.fiador_nit }}
                </td>
              </tr>
              <tr>
                <td class="text--secondary font-weight-bold text-body-2">
                  Teléfono principal
                </td>
                <td class="text--secondary font-weight-regular text-body-2" align="left">
                  {{ detalleEvaluacion.fiador_celular }}
                </td>
              </tr>
              <tr>
                <td class="text--secondary font-weight-bold text-body-2">
                  Teléfono secundario
                </td>
                <td class="text--secondary font-weight-regular text-body-2" align="left">
                  {{ detalleEvaluacion.fiador_telefono_casa }}
                </td>
              </tr>
              <tr>
                <td class="text--secondary font-weight-bold text-body-2">
                  Número de contador nis
                </td>
                <td class="text--secondary font-weight-regular text-body-2" align="left">
                  {{ detalleEvaluacion.fiador_nocontador_nis }}
                </td>
              </tr>
              <tr>
                <td class="text--secondary font-weight-bold text-body-2">
                  Teléfono de trabajo
                </td>
                <td class="text--secondary font-weight-regular text-body-2" align="left">
                  {{ detalleEvaluacion.fiador_trabajo_telefono }}
                </td>
              </tr>
              <tr>
                <td class="text--secondary font-weight-bold text-body-2">
                  Tipo de vivienda
                </td>
                <td class="text--secondary font-weight-regular text-body-2" align="left">
                  {{ detalleEvaluacion.fiador_vivienda_tipo }}
                </td>
              </tr>
              <tr>
                <td class="text--secondary font-weight-bold text-body-2">
                  Tiempo de vivir en el domicilio
                </td>
                <td class="text--secondary font-weight-regular text-body-2" align="left">
                  {{
                    tiempoResidenciaMeses(
                      detalleEvaluacion.fiador_cantidad_de_tiempo_en_vivienda_unidades,
                      detalleEvaluacion.fiador_cantidad_de_tiempo_en_vivienda_metrica
                    )
                  }}
                </td>
              </tr>
              <tr>
                <td class="text--secondary font-weight-bold text-body-2">
                  Ubicación
                </td>
                <td class="text--secondary font-weight-regular text-body-2" align="left"
                  v-if=detalleEvaluacion.fiador_vivienda_ubicacion>

                  {{
                    JSON.parse(detalleEvaluacion.fiador_vivienda_ubicacion).direccion
                  }}
                </td>
              </tr>
              <tr>
                <td class="text--secondary font-weight-bold text-body-2">
                  Dirección
                </td>
                <td class="text--secondary font-weight-regular text-body-2" align="left">
                  {{ detalleEvaluacion.fiador_direccion_consejera }}
                </td>
              </tr>
              <tr>
                <td class="text--secondary font-weight-bold text-body-2">
                  Dirección de trabajo
                </td>
                <td class="text--secondary font-weight-regular text-body-2" align="left">
                  {{ detalleEvaluacion.fiador_trabajo_direccion }}
                </td>
              </tr>
              <tr>
                <td class="text--secondary font-weight-bold text-body-2">
                  Dirección de entrega
                </td>
                <td class="text--secondary font-weight-regular text-body-2" align="left">
                  {{ detalleEvaluacion.fiador_direccion_de_entrega }}
                </td>
              </tr>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col id="flujo" cols="12">
        <!-- "Buro Interno" Steps -->
        <v-card class="mb-4 pa-4">
          <v-card-title class="text-center justify-center">
            Flujo de evaluación
          </v-card-title>
          <v-row class="mt-4" dense>
            <v-col v-for="(step, index) in evaluacion_flow" :key="index" cols="auto" class="d-flex align-center">
              <v-card class="px-3 py-2" :color="stepColor(step.color)" outlined>
                <div class="d-flex align-center">
                  <span v-if="step.label == 'Buró interno'" @click="showburoInternoDetailsDialog = true">{{ step.label
                  }}</span>
                  <span v-else>{{ step.label }}</span>
                  <v-icon v-if="step.color == 'green'" :color="step.color" class="ml-2">mdi-check-circle</v-icon>
                  <v-icon v-else-if="step.color == 'yellow'" :color="step.color" class="ml-2">mdi-alert-circle</v-icon>
                  <v-icon v-else-if="step.color == 'red'" :color="step.color"
                    class="ml-2">mdi-close-circle-outline</v-icon>
                  <v-icon v-else-if="step.color == 'none'" :color="'grey'" class="ml-2"></v-icon>
                  <v-icon v-else :color="step.color" class="ml-2">mdi-minus-circle-outline</v-icon>
                </div>
              </v-card>
              <v-icon v-if="index < evaluacion_flow.length - 1">mdi-chevron-right</v-icon>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col id="flujo2" cols="12">
        <v-card>
          <v-card-title class="text-center justify-center">
            Flujo de evaluación
          </v-card-title>
          <v-card-text>
            <v-simple-table dense>
              <tr>
                <td><strong>Buró interno</strong></td>
                <td>
                  Estado: <span :class="[
                    `${getColor(
                      buroInternoResult.finalResult.status
                    )}--text`,
                  ]"> {{
                    buroInternoResult?.finalResult?.status || 'N/A'
                  }}</span>
                  , Motivo: {{ buroInternoResult?.finalResult?.reason || '' }}
                </td>
              </tr>
              <tr v-for="(detail, key) in buroInternoResult.details" :key="key">
                <td>
                  <span style="font-size: 13px" class="font pl-2">
                    {{ key }}</span>
                </td>
                <td v-if="buroInternoResult?.finalResult?.status != 'NO EXISTE'">


                  <v-icon v-if="getColor(detail) == 'green'" :color="getColor(detail)"
                    class="pr-2">mdi-check-circle</v-icon>
                  <v-icon v-else-if="getColor(detail) == 'yellow'" :color="getColor(detail)"
                    class="pr-2">mdi-alert-circle</v-icon>
                  <v-icon v-else-if="getColor(detail) == 'red'" :color="getColor(detail)"
                    class="pr-2">mdi-close-circle-outline</v-icon>
                  <v-icon v-else-if="getColor(detail) == 'none'" :color="'grey'" class="pr-2"></v-icon>
                  <v-icon v-else :color="getColor(detail)" class="pr-2">mdi-minus-circle-outline</v-icon>
                </td>
                <td v-if="buroInternoResult?.finalResult?.status == 'NO EXISTE'">
                  --
                </td>
              </tr>
              <tr>
                <td><strong>Políticas internas</strong></td>
                <td>
                  Estado:
                  <span :class="[
                    `${getColor(
                      politicasInternasResult.finalResult.status
                    )}--text`,
                  ]">{{
                    politicasInternasResult?.finalResult?.status || 'N/A'
                  }}</span>


                  <span class="mr-1" v-for="(policy, index) in politicasInternasResult?.validations || []" :key="index">
                    , <strong>{{ policy.rule }}</strong> - {{
                      policy.reason
                    }}

                  </span>
                </td>
              </tr>
              <tr v-for="(detail, key) in politicasInternasResult.details" :key="key">
                <td>
                  <span style="font-size: 12px" class="font pl-2">
                    {{ key }}</span>
                </td>
                <td>
                  <v-icon v-if="getColor(detail) == 'green'" :color="getColor(detail)"
                    class="pr-2">mdi-check-circle</v-icon>
                  <v-icon v-else-if="getColor(detail) == 'yellow'" :color="getColor(detail)"
                    class="pr-2">mdi-alert-circle</v-icon>
                  <v-icon v-else-if="getColor(detail) == 'red'" :color="getColor(detail)"
                    class="pr-2">mdi-close-circle-outline</v-icon>
                  <v-icon v-else-if="getColor(detail) == 'none'" :color="'grey'" class="pr-2"></v-icon>
                  <v-icon v-else :color="getColor(detail)" class="pr-2">mdi-minus-circle-outline</v-icon>
                </td>
              </tr>
              <tr>
                <td>
                  <span style="font-size: 12px" class="font pl-2">
                    Tipo de cliente</span>
                </td>
                <td>
                  <strong>{{
                    detalleEvaluacion.fiador_buro_tipo_de_usuario
                  }}</strong>
                </td>
              </tr>
              <tr v-if="detalleEvaluacion.pais !== 'Honduras'">
                <td><strong>{{detalleEvaluacion.pais == 'Guatemala'?'TRANSUNION':'EQUIFAX'}}</strong></td>
                <td>
                  Estado:
                  <span :class="[
                    `${getColor(
                      detalleEvaluacion.fiador_resultado_evaluacion_equifax
                    )}--text`,
                  ]">
                    {{
                      detalleEvaluacion.fiador_resultado_evaluacion_equifax || 'N/A'
                    }}</span>
                </td>
              </tr>
              <template v-if="detalleEvaluacion.pais == 'Guatemala' && typeof equifaxResult === 'object'">

                <tr v-for="(evaluacion) in equifaxResult" :key="evaluacion.regla">
                  <td>
                    <span style="font-size: 12px" class="font pl-2">
                      {{ evaluacion.regla }}</span>
                  </td>
                  <td>
                    <v-icon v-if="getColor(evaluacion.resultado) == 'green'" :color="getColor(evaluacion.resultado)"
                      class="pr-2">mdi-check-circle</v-icon>
                    <v-icon v-else-if="getColor(evaluacion.resultado) == 'yellow'" :color="getColor(evaluacion.resultado)"
                      class="pr-2">mdi-alert-circle</v-icon>
                    <v-icon v-else-if="getColor(evaluacion.resultado) == 'red'" :color="getColor(evaluacion.resultado)"
                      class="pr-2">mdi-close-circle-outline</v-icon>
                    <v-icon v-else-if="getColor(evaluacion.resultado) == 'none'" :color="'grey'" class="pr-2"></v-icon>
                    <v-icon v-else :color="getColor(evaluacion.resultado)" class="pr-2">mdi-minus-circle-outline</v-icon>
                  </td>
                </tr>
              </template>

              <template v-if="detalleEvaluacion.pais == 'El Salvador' && typeof equifaxResult === 'object'">
                <tr v-for="(evaluacion) in equifaxResult.TransunionReglasCredito" :key="evaluacion.regla">
                  <td>
                    <span style="font-size: 12px" class="font pl-2">
                      {{ evaluacion.regla }}</span>
                  </td>
                  <td>
                    <v-icon v-if="getColor(evaluacion.resultado) == 'green'" :color="getColor(evaluacion.resultado)"
                      class="pr-2">mdi-check-circle</v-icon>
                    <v-icon v-else-if="getColor(evaluacion.resultado) == 'yellow'" :color="getColor(evaluacion.resultado)"
                      class="pr-2">mdi-alert-circle</v-icon>
                    <v-icon v-else-if="getColor(evaluacion.resultado) == 'red'" :color="getColor(evaluacion.resultado)"
                      class="pr-2">mdi-close-circle-outline</v-icon>
                    <v-icon v-else-if="getColor(evaluacion.resultado) == 'none'" :color="'grey'" class="pr-2"></v-icon>
                    <v-icon v-else :color="getColor(evaluacion.resultado)" class="pr-2">mdi-minus-circle-outline</v-icon>
                  </td>
                </tr>
              </template>

              <template v-if="detalleEvaluacion.pais == 'Honduras' && hondurasResults">
                <tr>
                  <td><strong>TRANSUNION HN</strong></td>
                  <td>Estado: <span :class="[`${getColor(hondurasResults.tuEvaluacion)}--text`]">{{ hondurasResults.tuEvaluacion }}</span></td>
                </tr>
                <tr v-if="hondurasResults.tuNoExiste">
                  <td colspan="2" style="font-size:12px" class="pl-2 grey--text">{{ hondurasResults.tuNoExisteMsg }}</td>
                </tr>
                <template v-else>
                  <tr v-for="regla in hondurasResults.tuRules" :key="'tu-' + regla.regla">
                    <td><span style="font-size: 12px" class="font pl-2">{{ regla.regla }}</span></td>
                    <td>
                      <v-icon v-if="getColor(regla.resultado) == 'green'" :color="getColor(regla.resultado)" class="pr-2">mdi-check-circle</v-icon>
                      <v-icon v-else-if="getColor(regla.resultado) == 'yellow'" :color="getColor(regla.resultado)" class="pr-2">mdi-alert-circle</v-icon>
                      <v-icon v-else-if="getColor(regla.resultado) == 'red'" :color="getColor(regla.resultado)" class="pr-2">mdi-close-circle-outline</v-icon>
                      <v-icon v-else :color="'grey'" class="pr-2">mdi-minus-circle-outline</v-icon>
                    </td>
                  </tr>
                </template>
                <tr>
                  <td><strong>EQUIFAX HN</strong></td>
                  <td>Estado: <span :class="[`${getColor(hondurasResults.efEvaluacion)}--text`]">{{ hondurasResults.efEvaluacion }}</span></td>
                </tr>
                <tr v-if="hondurasResults.efNoExiste">
                  <td colspan="2" style="font-size:12px" class="pl-2 grey--text">{{ hondurasResults.efNoExisteMsg }}</td>
                </tr>
                <template v-else>
                  <tr v-for="regla in hondurasResults.efRules" :key="'ef-' + regla.regla">
                    <td><span style="font-size: 12px" class="font pl-2">{{ regla.regla }}</span></td>
                    <td>
                      <v-icon v-if="getColor(regla.resultado) == 'green'" :color="getColor(regla.resultado)" class="pr-2">mdi-check-circle</v-icon>
                      <v-icon v-else-if="getColor(regla.resultado) == 'yellow'" :color="getColor(regla.resultado)" class="pr-2">mdi-alert-circle</v-icon>
                      <v-icon v-else-if="getColor(regla.resultado) == 'red'" :color="getColor(regla.resultado)" class="pr-2">mdi-close-circle-outline</v-icon>
                      <v-icon v-else :color="'grey'" class="pr-2">mdi-minus-circle-outline</v-icon>
                    </td>
                  </tr>
                </template>
                <tr>
                  <td><strong>Resultado final Honduras</strong></td>
                  <td><span :class="[`${getColor(detalleEvaluacion.fiador_resultado_evaluacion_equifax)}--text`]"><strong>{{ detalleEvaluacion.fiador_resultado_evaluacion_equifax || 'N/A' }}</strong></span></td>
                </tr>
              </template>


            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col id="equifax" cols="12">
        <v-card>
          <v-card-title class="text-center justify-center">
            Informe de buró
            <span v-if="detalleEvaluacion.pais == 'Guatemala'">TRANSUNION</span>
            <span v-else-if="detalleEvaluacion.pais == 'Honduras'">TRANSUNION HN + EQUIFAX HN</span>
            <span v-else>EQUIFAX</span>
          </v-card-title>

          <v-card-text v-if="detalleEvaluacion.pais == 'El Salvador' && svReglas.length > 0">
            <v-card outlined>
              <v-card-title class="text-body-1 font-weight-bold">EQUIFAX SV — Reglas de evaluación</v-card-title>
              <v-card-text>
                <v-simple-table dense>
                  <tr v-for="regla in svReglas" :key="'sv-inf-' + regla.regla">
                    <td style="font-size:12px">{{ regla.regla }}</td>
                    <td>
                      <v-icon v-if="getColor(regla.resultado) == 'green'" :color="getColor(regla.resultado)" small>mdi-check-circle</v-icon>
                      <v-icon v-else-if="getColor(regla.resultado) == 'yellow'" :color="getColor(regla.resultado)" small>mdi-alert-circle</v-icon>
                      <v-icon v-else-if="getColor(regla.resultado) == 'red'" :color="getColor(regla.resultado)" small>mdi-close-circle-outline</v-icon>
                      <v-icon v-else color="grey" small>mdi-minus-circle-outline</v-icon>
                    </td>
                  </tr>
                </v-simple-table>
              </v-card-text>
            </v-card>
          </v-card-text>

          <v-card-text v-if="detalleEvaluacion.pais == 'Honduras' && hondurasResults">
            <v-tabs v-model="hnTab" background-color="transparent" grow>
              <v-tab>TRANSUNION HN</v-tab>
              <v-tab>EQUIFAX HN</v-tab>
            </v-tabs>
            <v-tabs-items v-model="hnTab">
              <v-tab-item>
                <v-alert v-if="hondurasResults.tuNoExiste" type="info" dense text class="mt-2 mb-0">
                  {{ hondurasResults.tuNoExisteMsg }}
                </v-alert>
                <v-simple-table v-else dense class="mt-2">
                  <tbody>
                    <tr v-for="regla in hondurasResults.tuRules" :key="'tu-inf-' + regla.regla">
                      <td style="font-size:12px">{{ stripRulePrefix(regla.regla) }}</td>
                      <td>
                        <v-icon v-if="getColor(regla.resultado) == 'green'" :color="getColor(regla.resultado)" small>mdi-check-circle</v-icon>
                        <v-icon v-else-if="getColor(regla.resultado) == 'yellow'" :color="getColor(regla.resultado)" small>mdi-alert-circle</v-icon>
                        <v-icon v-else-if="getColor(regla.resultado) == 'red'" :color="getColor(regla.resultado)" small>mdi-close-circle-outline</v-icon>
                        <v-icon v-else color="grey" small>mdi-minus-circle-outline</v-icon>
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
                <template v-if="hondurasResults.tuXmlUrl">
                  <v-btn x-small color="primary" class="mt-3 mb-2"
                    :href="VUE_APP_FEATHERS_SERVER + hondurasResults.tuXmlUrl"
                    target="_blank" download>
                    <v-icon small left>mdi-download</v-icon>
                    Ver XML TransUnion HN
                  </v-btn>
                  <gestionBuroTransunion :prop_xml="VUE_APP_FEATHERS_SERVER + hondurasResults.tuXmlUrl"></gestionBuroTransunion>
                </template>
              </v-tab-item>
              <v-tab-item>
                <v-alert v-if="hondurasResults.efNoExiste" type="info" dense text class="mt-2 mb-0">
                  {{ hondurasResults.efNoExisteMsg }}
                </v-alert>
                <v-simple-table v-else dense class="mt-2">
                  <tbody>
                    <tr v-for="regla in hondurasResults.efRules" :key="'ef-inf-' + regla.regla">
                      <td style="font-size:12px">{{ stripRulePrefix(regla.regla) }}</td>
                      <td>
                        <v-icon v-if="getColor(regla.resultado) == 'green'" :color="getColor(regla.resultado)" small>mdi-check-circle</v-icon>
                        <v-icon v-else-if="getColor(regla.resultado) == 'yellow'" :color="getColor(regla.resultado)" small>mdi-alert-circle</v-icon>
                        <v-icon v-else-if="getColor(regla.resultado) == 'red'" :color="getColor(regla.resultado)" small>mdi-close-circle-outline</v-icon>
                        <v-icon v-else color="grey" small>mdi-minus-circle-outline</v-icon>
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
                <template v-if="!hondurasResults.efNoExiste && equifaxResult.equifax && equifaxResult.equifax.infoCrediticia">
                  <gestionBuroEquifaxTablas
                    :infotablas_segun_perfil="JSON.stringify(equifaxResult.equifax)"
                    :equifax_json="equifaxResult.equifax"
                    :equifax_json_actual="[]"
                    :equifax_json_historico="[]"
                    :detalleEvaluacion="detalleEvaluacion"
                    :reporteURL="detalleEvaluacion.fiador_resultado_evaluacion_equifax_pdf_url"
                  />
                </template>
              </v-tab-item>
            </v-tabs-items>
          </v-card-text>
          <v-card-text v-else-if="equifaxResult && equifaxResult.infoCrediticia && equifaxResult.infoCrediticia.ScoreActual">
            <gestionBuroEquifaxTablas :infotablas_segun_perfil="detalleEvaluacion.fiador_resultado_evaluacion_equifax_detalle" :reporteURL="detalleEvaluacion.fiador_resultado_evaluacion_equifax_pdf_url"
              :detalleEvaluacion="detalleEvaluacion" :equifax_json="equifaxResult"
              :equifax_json_actual="equifaxResult.infoCrediticia.ScoreActual" :equifax_json_historico="equifaxResult.infoCrediticia.scoreHistorico
                "></gestionBuroEquifaxTablas>
          </v-card-text>
          <v-card-text v-else-if="detalleEvaluacion.fiador_resultado_evaluacion_equifax_pdf_url">
            <v-btn
              x-small
              :href="VUE_APP_FEATHERS_SERVER + detalleEvaluacion.fiador_resultado_evaluacion_equifax_pdf_url"
              target="_blank" download color="primary" class="ma-2">
              <v-icon small left>mdi-download</v-icon>
              Descargar Respuesta XML de transunion
            </v-btn>
            <gestionBuroTransunion :prop_xml="VUE_APP_FEATHERS_SERVER + detalleEvaluacion.fiador_resultado_evaluacion_equifax_pdf_url"></gestionBuroTransunion>
          </v-card-text>
          <v-card-text v-else>
            <pre>{{ equifaxResult }}</pre>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="showburoInternoDetailsDialog" width="900">
      <v-card>
        <v-card-title class="text-center justify-center">
          Detalles del Buró Interno
        </v-card-title>
        <v-card-text>
          <pre>{{ JSON.parse(detalleEvaluacion.fiador_resultado_evaluacion_buro_interno) }}</pre>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="showburoInternoDetailsDialog = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>

    </v-dialog>

  </v-container>
</template>
<script>
import gestionBuroTransunion from './gestion_buro_transunion.vue'
import { mapActions } from 'vuex';
import moment from 'moment';
require('moment/locale/es.js');
import gestionBuroEquifaxTablas from './gestion_buro_equifax_tablas.vue';
export default {
  name: 'vistaEvaluacion',
  props: ['detalleEvaluacion'],
  components: {
    gestionBuroEquifaxTablas,
    gestionBuroTransunion
  },
  data() {
    return {
      showburoInternoDetailsDialog: false,
      hnTab: 0,
      isBuroInternoDialogOpen: false,
      isEquifaxDialogOpen: false,
      //
      reingresoSelect: null, //variable para almacenar el valor del reingreso seleccionado
      //datos temporales con valores para el select de "Reingreso"
      itemsReingreso: ['reingreso', 'nuevo'],
    };
  },

  computed: {
    documento_de_identificacion(){
      if (this.detalleEvaluacion.pais == 'Guatemala') {
        return 'DPI'
      } else if (this.detalleEvaluacion.pais == 'El Salvador') {
        return 'DUI'
      } else if (this.detalleEvaluacion.pais == 'Honduras') {
        return 'DNI'
      } else {
        return 'Documento de identificación'
      }
    },
    VUE_APP_FEATHERS_SERVER() {
      return process.env.VUE_APP_FEATHERS_SERVER;
    },
    stepColor() {
      return (color) => {
        switch (color) {
          case 'green':
            return 'green lighten-4';
          case 'red':
            return 'red lighten-4';
          case 'yellow':
            return 'yellow lighten-4';
          default:
            return 'grey lighten-4';
        }
      };
    },
    evaluacion_flow() {

      /**inicio */
      let flow = [{ label: "Inicio", color: 'none' }];

      /**adjuntar buro interno */
      if (this.buroInternoResult && this.buroInternoResult.finalResult && this.buroInternoResult.finalResult.status) {
        flow.push({ label: "Buró interno", color: this.getColor(this.buroInternoResult.finalResult.status) })
      } else {
        flow.push({ label: "Buró interno", color: this.getColor(this.buroInternoResult.finalResult.status) })
      }


      /**adjuntar políticas internas */
      for (const [key, value] of Object.entries(this.politicasInternasResult.details)) {
        flow.push({
          label: 'politica: ' + key,
          color: this.getColor(value)
        });
      }
      if (this.detalleEvaluacion.pais == 'Guatemala') {
        flow.push({ label: 'TRANSUNION', color: this.getColor(this.detalleEvaluacion.fiador_resultado_evaluacion_equifax) });
      } else if (this.detalleEvaluacion.pais == 'Honduras' && this.hondurasResults) {
        flow.push({ label: 'TRANSUNION HN', color: this.getColor(this.hondurasResults.tuEvaluacion) });
        flow.push({ label: 'EQUIFAX HN', color: this.getColor(this.hondurasResults.efEvaluacion) });
      } else {
        flow.push({ label: 'EQUIFAX 360', color: this.getColor(this.detalleEvaluacion.fiador_resultado_evaluacion_equifax) });
      }
      /**fin */
      flow.push({ label: "Fin", color: 'none' })

      return flow;

    },
    flag_gestion_terminada() {
      if (this.detalleEvaluacion.flag_precalificacion_concluidas == 1) {
        return true;
      } else if (this.detalleEvaluacion.flag_precalificacion_cancelada == 1) {
        return true;
      } else if (this.detalleEvaluacion.flag_precalificacion_eliminada == 1) {
        return true;
      } else {
        return false;
      }
    },
    buroInternoResult() {
      // Parse the JSON string from resultado_evaluacion_buro_interno
      try {
        return JSON.parse(
          this.detalleEvaluacion.fiador_resultado_evaluacion_buro_interno
        );
      } catch (e) {
        return {};
      }
    },
    politicasInternasResult() {
      // Parse the JSON string from resultado_evaluacion_politicas_internas
      try {
        return JSON.parse(
          this.detalleEvaluacion.fiador_resultado_evaluacion_politicas_internas
        );
      } catch (e) {
        return {};
      }
    },
    equifaxResult() {
      let equifaxData = this.detalleEvaluacion.fiador_resultado_evaluacion_equifax_detalle;
      try {
        const parsed = JSON.parse(equifaxData);
        if (!parsed || typeof parsed !== 'object') return parsed;
        const ic = parsed.infoCrediticia;
        if (ic && ic.scoreActual && !ic.ScoreActual) {
          ic.ScoreActual = ic.scoreActual;
        }
        return parsed;
      } catch (e) {
        return equifaxData;
      }
    },
    hondurasResults() {
      if (this.detalleEvaluacion.pais !== 'Honduras') return null;
      const data = this.equifaxResult;
      if (!data || typeof data !== 'object') return null;
      const tuRaw = data.transunion;
      const tuNoExiste = typeof tuRaw?.evaluaciones === 'string';
      const tuNoExisteMsg = tuNoExiste ? tuRaw.evaluaciones : '';
      const tuRules = Array.isArray(tuRaw) ? tuRaw : (Array.isArray(tuRaw?.evaluaciones) ? tuRaw.evaluaciones : []);
      const tuXmlUrl = Array.isArray(tuRaw) ? '' : (tuRaw?.xml_url || '');
      const efNoExiste = data.equifax?.noExiste === true;
      const efNoExisteMsg = efNoExiste ? (data.equifax?.message || 'Esta persona no existe en la base de datos de Equifax Honduras.') : '';
      const efRules = Array.isArray(data.equifax?.EquifaxHNReglas) ? data.equifax.EquifaxHNReglas : [];
      const worstOf = (rules) => {
        if (rules.some(r => r.resultado === 'rechazado')) return 'rechazado';
        if (rules.some(r => r.resultado === 'revisión')) return 'revisión';
        return 'aprobado';
      };
      return {
        tuEvaluacion: tuRules.length ? worstOf(tuRules) : 'aprobado',
        efEvaluacion: efRules.length ? worstOf(efRules) : 'aprobado',
        tuRules,
        efRules,
        tuXmlUrl,
        tuNoExiste,
        tuNoExisteMsg,
        efNoExiste,
        efNoExisteMsg,
      };
    },
    svReglas() {
      if (this.detalleEvaluacion.pais !== 'El Salvador') return [];
      const data = this.equifaxResult;
      if (!data || typeof data !== 'object') return [];
      return Array.isArray(data.TransunionReglasCredito) ? data.TransunionReglasCredito : [];
    },
    isEquifaxJson() {
      return typeof this.equifaxResult === 'object';
    },
    parsedEquifaxDetail() {
      return this.isEquifaxJson
        ? JSON.stringify(this.equifaxResult, null, 2)
        : this.equifaxResult;
    },
  },
  methods: {
    stripRulePrefix(regla) {
      return typeof regla === 'string' ? regla.replace(/^R\d+\s*[—–-]\s*/, '') : regla;
    },
    capitalizeFirstLetter(val) {
      if (typeof val === 'string') {
        let adjustedVal = val;
        if (val.toLowerCase() === 'nacionalizado' || val.toLowerCase() === 'extranjero') {
          adjustedVal = val.slice(0, -1) + 'a'; // Cambia la última letra a 'a'
        }
        return adjustedVal.charAt(0).toUpperCase() + adjustedVal.slice(1);
      }
      return val; // Devuelve el valor sin cambios si no es una cadena
    },
    imagenEstadoEvaluacion(estado) {
      switch (estado) {
        case 'aprobado':
          return require('@/assets/images/aprobado.png');
        case 'revisión':
          return require('@/assets/images/revision.png');
        case 'rechazado':
          return require('@/assets/images/rechazado.png');
        default:
          return require('@/assets/images/rechazado.png');
      }
    },
    tiempoResidenciaMeses(tiempo, metrica) {
      if (metrica == 'Años') {
        return tiempo * 12 + ' Meses';
      }
      if (metrica == 'Días') {
        return Math.round(tiempo / 30) + ' Meses';
      }
      return tiempo + ' Meses';
    },
    fnActualizarTipoDeUsuario() {
      this.patchGestiones([
        this.detalleEvaluacion.id,
        {
          fiador_buro_tipo_de_usuario: this.detalleEvaluacion.fiador_buro_tipo_de_usuario,
        },
      ]).then(() => {
        this.$notify({
          title: 'Gestiones',
          text: 'Se ha actualizado el tipo de cliente.',
          color: '#4caf50',
          timeout: 3000,
        });
      });
    },
    ...mapActions('Gestiones', {
      findGestiones: 'find',
      createGestiones: 'create',
      patchGestiones: 'patch',
    }),
    fnGetDate(date) {
      return date ? moment(date).format('DD-MM-YYYY') : '';
    },
    fnGetDateTime(date) {
      return date ? moment(date).format('DD-MM-YYYY HH:mm:ss a') : '';
    },
    fnGetDateUTC(date) {
      return date ? moment(date).utc().format('DD-MM-YYYY') : '';
    },
    getColor(estado) {
      if (
        estado == 'rechazado' ||
        estado == 'RECHAZADO' ||
        estado == 'DENEGADO' ||
        estado == 'DENEGAR'
      ) {
        return 'red';
      } else if (
        estado == 'REVISIÓN' ||
        estado == 'revision' ||
        estado == 'revisión'
      ) {
        return 'yellow';
      } else if (
        estado == 'aprobado' ||
        estado == 'APROBADO' ||
        estado == 'APROBADO AUTOMATICO'
      ) {
        return 'green';
      } else {
        return 'grey';
      }
    },
    showBuroInternoDetails() {
      this.isBuroInternoDialogOpen = true;
    },
    showEquifaxDetails() {
      this.isEquifaxDialogOpen = true;
    },
  },
};
</script>
<style>
.my-masonry-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(900px, 1fr));
  grid-gap: 1rem;
}
</style>
